import { BREAK_PLOT_MAX_IN } from 'enums/pitch-performance.enums';
import {
  IAxisExtentLabel,
  IAxisLabelShapeProps,
} from 'interfaces/recharts/i-axis-labels';

const AXIS_LABEL_FONT_SIZE_PX = 12;
const AXIS_LABEL_OFFSET_PX = 4;

// move the horizontal axis labels down (+) below the line
const H_AXIS_LABEL_DY_PX = 16;

// move the vertical axis labels to the left (-) of the line
const V_AXIS_LABEL_DX_PX = -4;
// additional vertical offset for the vertical axis labels
const V_AXIS_LABEL_DY_PX = 4;

/** axis extent label, drawn just inside the plot alongside a zero line */
export const AxisExtentLabel = ({
  cx,
  cy,
  fill,
  text,
  dx = 0,
  dy = 0,
  textAnchor = 'start',
}: IAxisLabelShapeProps) => {
  if (cx === undefined || cy === undefined || !text) {
    return null;
  }

  return (
    <text
      x={cx + dx}
      y={cy + dy}
      fill={fill}
      fontSize={AXIS_LABEL_FONT_SIZE_PX}
      textAnchor={textAnchor}
    >
      {text}
    </text>
  );
};
export const AXIS_EXTENT_LABELS: IAxisExtentLabel[] = [
  {
    // right
    key: 'hz-max',
    x: BREAK_PLOT_MAX_IN,
    y: 0,
    text: `${BREAK_PLOT_MAX_IN}"`,
    dx: -AXIS_LABEL_OFFSET_PX,
    dy: H_AXIS_LABEL_DY_PX,
    textAnchor: 'end',
  },
  {
    // left
    key: 'hz-min',
    x: -BREAK_PLOT_MAX_IN,
    y: 0,
    text: `-${BREAK_PLOT_MAX_IN}"`,
    dx: AXIS_LABEL_OFFSET_PX,
    dy: H_AXIS_LABEL_DY_PX,
    textAnchor: 'start',
  },
  {
    // top
    key: 'vt-max',
    x: 0,
    y: BREAK_PLOT_MAX_IN,
    text: `${BREAK_PLOT_MAX_IN}"`,
    dx: V_AXIS_LABEL_DX_PX,
    dy: AXIS_LABEL_FONT_SIZE_PX + V_AXIS_LABEL_DY_PX,
    textAnchor: 'end',
  },
  {
    // bottom
    key: 'vt-min',
    x: 0,
    y: -BREAK_PLOT_MAX_IN,
    text: `-${BREAK_PLOT_MAX_IN}"`,
    dx: V_AXIS_LABEL_DX_PX,
    dy: -(AXIS_LABEL_OFFSET_PX + V_AXIS_LABEL_DY_PX),
    textAnchor: 'end',
  },
];
